import React from "react";
import styles from "./index.module.scss";
import { renderRichText } from "@/utils/formatters";
import { useRouter } from "next/router";


const ProductFeatureGallery = ({ productFeatureGalleryData }) => {
    const { locale } = useRouter()
  if (!productFeatureGalleryData?.images?.length) return null;

  const items = productFeatureGalleryData.images;

  return (
    <section className={styles.section}>
      <div className={styles.container}>
        {items.map((item) => {
          const {
            imageUrl,
            internalTitle,
            alt,
            description,
          } = item.fields || {};

          if (!imageUrl) return null;

          return (
            <div className={styles.card} key={item.sys.id}>
              <img
                src={imageUrl}
                alt={alt || internalTitle || ""}
                className={styles.image}
              />

              <div className={styles.details}>
                {internalTitle && (
                  <div className={styles.title}>
                    {internalTitle}
                  </div>
                )}

                {description && (
                  <div className={styles.description}>
                    {renderRichText(description, locale)}
                  </div>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
};

export default ProductFeatureGallery;